import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LectureItemPage from "../../components/organisms/lecture/lectureItemPage";
import Empty from "../../components/molecules/empty";
import Pagination from "../../components/molecules/pagination";
import LSRgH2HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import OnboardingModal from "../../components/templates/modals/onboardingModal";
import SelecteBoxValue from "../../components/organisms/selectbox/selecteBoxValue";

import LectureApi from "../../api/lecture.api";
import { errorHandler } from "../../util/errorHandler";
import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";
import OnboardingApi from "../../api/onboarding.api";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import { toast } from "react-toastify";
import Loading from "../../components/templates/loading";

const LectureList = () => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  const [categoryBoxOpen, setCategoryBoxOpen] = useState(false);
  const [categoryValue, setCategoryValue] = useState(-1);
  const [categoryList, setCategoryList] = useState([
    {
      title: "전체",
      value: -1,
    },
  ]);

  const [productList, setProductList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const page = useMemo(() => {
    const pageParam = Number(searchParams.get("page"));
    return Number.isInteger(pageParam) && pageParam > 0 ? pageParam : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 9, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  const [recommendList, setRecommendList] = useState([]);
  const [isOnboarding, setIsOnboarding] = useState(false);
  const [isOnboardingModal, setIsOnboardingModal] = useState(false);
  const [isRecommendLoading, setIsRecommendLoading] = useState(false);

  useEffect(() => {
    categoryListFunc();

    if (sessionStorage.getItem("isLogin") === "true") {
      onBoardingInfoFunc();
    }
  }, []);

  useEffect(() => {
    const requestedCategory = Number(searchParams.get("categoryValue"));
    setCategoryValue(
      Number.isInteger(requestedCategory) && requestedCategory > 0
        ? requestedCategory
        : -1,
    );

    dataListFunc();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isOnboarding) {
      onBoardingDataListFunc();
    }
  }, [isOnboarding]);

  const onBoardingInfoFunc = async () => {
    try {
      const response = (
        await OnboardingApi.getList({
          page: 1,
          size: 0,
        })
      ).data.data.content;

      if (response && response.length > 0) {
        setIsOnboarding(true);
      } else {
        setIsOnboarding(false);
        setIsOnboardingModal(true);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const categoryListFunc = async () => {
    try {
      const studyCList = (
        await LectureApi.getCategoryList({
          page: 1,
          size: 0,
          lectureCategoryType: "PAID_LECTURE",
          activation: "Active",
        })
      ).data.data.content;

      const categoryTemp = (studyCList ?? []).map((item) => {
        return {
          ...item,
          value: item.id,
        };
      });

      setCategoryList([{ title: "전체", value: -1 }, ...categoryTemp]);
    } catch (error) {
      errorHandler(error);
    }
  };

  const dataListFunc = async () => {
    setIsLoading(true);
    try {
      const data = {
        page: page,
        size: pagination.size,
        lectureCategoryType: "PAID_LECTURE",
        activation: "Active",
      };

      const requestedCategory = Number(searchParams.get("categoryValue"));
      if (Number.isInteger(requestedCategory) && requestedCategory > 0) {
        data.lectureCategoryId = requestedCategory;
      }

      const response = (await LectureApi.getList(data)).data.data;

      setProductList(response.content ?? []);
      setPagination((current) => ({
        ...current,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / pagination.size),
      }));
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onBoardingDataListFunc = async () => {
    setIsRecommendLoading(true);
    try {
      const data = {
        page: 1,
        size: 10,
      };

      const result = await LectureApi.onBoardinglectureList(data);
      const response = result.data.data?.content ?? [];

      const slicedArray = response.slice(0, 3); // 앞에서 3개 요소를 자름
      setRecommendList(slicedArray);
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsRecommendLoading(false);
    }
  };

  return (
    <>
      <LectureListSection>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            width: "100%",
            position: "relative",
            objectFit: "contain",
          }}
        >
          <img
            onClick={() => {
              if (sessionStorage.getItem("isLogin") === "true") {
                setIsOnboardingModal(true);
              } else {
                toast("온보딩을 위해 로그인을 해주세요.");
                navigate(`${route.login}`);
              }
            }}
            style={{
              cursor: "pointer",
              width: "100%",
            }}
            src={
              isOnboarding
                ? isSmall
                  ? "/assets/images/onboarding_re_m.png"
                  : "/assets/images/onboarding_re.png"
                : isSmall
                  ? "/assets/images/onboarding_go_m.png"
                  : "/assets/images/onboarding_go.png"
            }
            alt="onboarding_re"
          />
        </div>

        <PCContainer
          style={{
            flexDirection: "column",
            padding: isMobile
              ? "40px 20px 80px 20px"
              : isTablet
                ? "40px 60px 80px 60px"
                : "80px 0px 150px 0px",
            width: "100%",
          }}
        >
          {isOnboarding ? (
            <div
              style={{
                marginBottom: isMobile ? 80 : 150,
              }}
            >
              <LSRgDisplay02
                style={{
                  color: "#000000",
                  marginBottom: isMobile ? 16 : 30,
                  fontSize: isMobile ? 16 : 24,
                  lineHeight: isMobile ? "22.4px" : "33.6px",
                }}
              >
                📌 {sessionStorage.getItem("name") || "회원"} 님만을 위한 맞춤
                강의 추천!
              </LSRgDisplay02>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: isMobile ? "19px 0px" : "30px",
                    flexDirection: "row",
                    justifyContent: isSmall ? "space-between" : "flex-start",
                    flexWrap: "wrap",
                    width: "100%",
                  }}
                >
                  {isRecommendLoading ? (
                    <Loading />
                  ) : recommendList.length > 0 ? (
                    recommendList.map((item) => {
                      return <LectureItemPage key={item.id} data={item} />;
                    })
                  ) : (
                    <Empty title={"등록된 강의가 없습니다."} />
                  )}
                </div>
              </div>
            </div>
          ) : null}

          <LSRgDisplay02
            style={{
              color: "#000000",
              marginBottom: isMobile ? 16 : isTablet ? 30 : 30,
              fontSize: isMobile ? 14 : 24,
              lineHeight: isMobile ? "19.6px" : "33.6px",
            }}
          >
            💰 카테고리별로 영상 강의를 찾아보세요
          </LSRgDisplay02>

          {isMobile ? (
            <SelecteBoxValue
              style={{
                marginBottom: 20,
              }}
              selectedValue={categoryValue}
              isOpen={categoryBoxOpen}
              wrapperHandler={() => {
                setCategoryBoxOpen(!categoryBoxOpen);
              }}
              itemList={categoryList}
              selectedValueSetterFunc={(value) => {
                setCategoryValue(value);
                navigate(`${route.lecture_list}?page=1&categoryValue=${value}`);
              }}
            />
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: "16px",
                marginBottom: 60,
              }}
            >
              {categoryList.map((item) => {
                return (
                  <StyledCategoryItem
                    key={item.value}
                    onClick={() => {
                      navigate(
                        `${route.lecture_list}?page=1&categoryValue=${item.value}`,
                      );
                    }}
                    isActive={categoryValue === item.value}
                    title={item.title}
                  />
                );
              })}
            </div>
          )}

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: isMobile ? "19px 0px" : "30px",
                flexDirection: "row",
                justifyContent: isSmall ? "space-between" : "flex-start",
                flexWrap: "wrap",
                width: "100%",
              }}
            >
              {isLoading ? (
                <Loading />
              ) : productList.length > 0 ? (
                productList.map((item) => {
                  return <LectureItemPage key={item.id} data={item} />;
                })
              ) : (
                <Empty title={"등록된 강의가 없습니다."} />
              )}
            </div>
          </div>

          {productList.length > 0 ? (
            <Pagination
              route={route.lecture_list}
              queryString={`categoryValue=${categoryValue}`}
              currentPage={Number(page)}
              totalPages={pagination.totalPages}
              rangeSize={pagination.rangeSize}
            />
          ) : null}
        </PCContainer>
      </LectureListSection>

      {isOnboardingModal ? (
        <OnboardingModal setVisiable={setIsOnboardingModal} isScroll={false} />
      ) : null}
    </>
  );
};

export default LectureList;

const LectureListSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;
